
import React from 'react';
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Paintbrush, LayoutTemplate } from 'lucide-react';

interface BannerCreationMethodStepProps {
  onSelectMethod: (isTemplate: boolean) => void;
}

const BannerCreationMethodStep: React.FC<BannerCreationMethodStepProps> = ({ onSelectMethod }) => {
  return (
    <div className="flex flex-col items-center">
      <h2 className="text-2xl font-bold mb-8 text-center">Choose how you want to create your banner</h2>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8 w-full max-w-4xl">
        <Card className="hover:shadow-lg transition-shadow cursor-pointer">
          <CardHeader className="bg-gradient-to-r from-blue-500 to-purple-500 text-white rounded-t-lg">
            <CardTitle className="text-xl">Custom Banner by Size</CardTitle>
            <CardDescription className="text-gray-100">
              Create a banner from scratch
            </CardDescription>
          </CardHeader>
          <CardContent className="pt-6 flex justify-center">
            <div className="rounded-full bg-blue-50 p-8 mb-4">
              <Paintbrush size={64} className="text-blue-500" />
            </div>
          </CardContent>
          <CardFooter>
            <Button onClick={() => onSelectMethod(false)} className="w-full bg-blue-500 hover:bg-blue-600">
              Start with Custom Size
            </Button>
          </CardFooter>
        </Card>

        <Card className="hover:shadow-lg transition-shadow cursor-pointer">
          <CardHeader className="bg-gradient-to-r from-green-500 to-teal-500 text-white rounded-t-lg">
            <CardTitle className="text-xl">Banner from Template</CardTitle>
            <CardDescription className="text-gray-100">
              Select from pre-designed templates
            </CardDescription>
          </CardHeader>
          <CardContent className="pt-6 flex justify-center">
            <div className="rounded-full bg-green-50 p-8 mb-4">
              <LayoutTemplate size={64} className="text-green-500" />
            </div>
          </CardContent>
          <CardFooter>
            <Button onClick={() => onSelectMethod(true)} className="w-full bg-green-500 hover:bg-green-600">
              Browse Templates
            </Button>
          </CardFooter>
        </Card>
      </div>
      
      <div className="mt-12 text-center text-gray-500 max-w-2xl">
        <p>
          Choose "Custom Banner" to start from scratch with specific dimensions, 
          or "Banner from Template" to use our pre-designed templates as a starting point.
        </p>
      </div>
    </div>
  );
};

export default BannerCreationMethodStep;
